/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// Infinite Options by ShopPad
// This theme removes event handlers attached to the add to cart button when the variant changes
// Reinit Infinite Options to reattach event handlers
document.addEventListener('variant:changed', function(event) {
  window.Shoppad.apps.infiniteoptions.init();
});

// Function to select the first available variant
function selectFirstAvailableVariant(productItem) {
  // Check if this product has multiple variant sets
  const hasMultipleVariantSets = productItem.querySelector('.change-variant-js-few-options__holder');
  
  if (hasMultipleVariantSets) {
    // For products with multiple variant sets (like size and color)
    const variantSets = productItem.querySelectorAll('.change-variant-js-few-options__holder');
    
    // Loop through each variant set
    for (const variantSet of variantSets) {
      // Find all variant buttons in this set
      const variantButtons = variantSet.querySelectorAll('.product-card-actions__variant-button');
      
      // Find the first available variant in this set
      let selectedVariant = null;
      for (const button of variantButtons) {
        if (!button.classList.contains('out-of-stock')) {
          selectedVariant = button;
          break;
        }
      }
      
      if (selectedVariant) {
        // Trigger a click on the first in-stock variant in this set
        selectedVariant.click();
      } else if (variantButtons.length) {
        // If all variants in this set are out-of-stock, trigger a click on the first variant
        variantButtons[0].click();
      }
    }
  } else {
    // For products with a single variant set (original behavior)
    const variantButtons = productItem.querySelectorAll('.product-card-actions__variant-button');
    
    // Filter those that are NOT out-of-stock
    let selectedVariant = null;
    for (const button of variantButtons) {
      if (!button.classList.contains('out-of-stock')) {
        selectedVariant = button;
        break;
      }
    }
    
    if (selectedVariant) {
      // Trigger a click on the first in-stock variant
      selectedVariant.click();
    } else if (variantButtons.length) {
      // If all variants are out-of-stock, trigger a click on the first variant
      variantButtons[0].click();
    }
  }
}

// Keep the jQuery handler for backward compatibility
jQuery(document).on('click', '.show-options-js', function(e) {
  e.preventDefault();

  var $productItem = jQuery(this).closest('.js-product-item');
  
  // Check if this product has multiple variant sets
  var $hasMultipleVariantSets = $productItem.find('.change-variant-js-few-options__holder').length > 0;
  
  if ($hasMultipleVariantSets) {
    // For products with multiple variant sets (like size and color)
    var $variantSets = $productItem.find('.change-variant-js-few-options__holder');
    
    // Loop through each variant set
    $variantSets.each(function() {
      // Find all variant buttons in this set
      var $variantButtons = jQuery(this).find('.product-card-actions__variant-button');
      
      // Find the first available variant in this set
      var $selectedVariant = $variantButtons.not('.out-of-stock').first();
      
      if ($selectedVariant.length) {
        // Trigger a click on the first in-stock variant in this set
        $selectedVariant.trigger('click');
      } else if ($variantButtons.length) {
        // If all variants in this set are out-of-stock, trigger a click on the first variant
        $variantButtons.first().trigger('click');
      }
    });
  } else {
    // For products with a single variant set (original behavior)
    var $variantButtons = $productItem.find('.product-card-actions__variant-button');
    
    // Filter those that are NOT out-of-stock.
    var $selectedVariant = $variantButtons.not('.out-of-stock').first();
    
    if ($selectedVariant.length) {
      // Trigger a click on the first in-stock variant.
      $selectedVariant.trigger('click');
    } else if ($variantButtons.length) {
      // If all variants are out-of-stock, trigger a click on the first variant.
      $variantButtons.first().trigger('click');
    }
  }
});


document.addEventListener('click', function(e) {
  const toggleBtn = e.target.closest('.quickAdd_bag, .show-options-js');
  const closeBtn = e.target.closest('.close-bottom-sheet');
  const addToCartBtn = e.target.closest('.add-to-cart-button-js');
  
  if (closeBtn || (addToCartBtn && window.innerWidth < 1024)) {
    e.preventDefault();
    const productCardActions = (closeBtn || addToCartBtn).closest('product-card-actions');
    if (productCardActions) {
      // Hide the card form
      const cardForm = productCardActions.querySelector('.card-form-js');
      const variantOptions = productCardActions.querySelector('.variant-options-js');
      const addToCartButton = productCardActions.querySelector('.add-to-cart-button-js');
      
      if (cardForm) cardForm.classList.add('hidden');
      if (addToCartButton) addToCartButton.classList.add('hidden');
      if (variantOptions) variantOptions.classList.add('hidden');
      
      // Remove active class from product-card-actions
      productCardActions.classList.remove('active');
      
      // Find and update the quick add button if it exists
      const productItem = productCardActions.closest('.ProductItem');
      if (productItem) {
        const quickAddBtn = productItem.querySelector('.quickAdd_bag');
        if (quickAddBtn) {
          quickAddBtn.classList.remove('active');
        }
        
        // Find and update the show-options-js button if it exists
        const showOptionsBtn = productCardActions.querySelector('.show-options-js');
        if (showOptionsBtn) {
          showOptionsBtn.classList.remove('active');
        }
      }
      
      // If this is an add to cart button, let the default action continue
      if (addToCartBtn) {
        return;
      }
    }
  } else if (toggleBtn) {
    e.preventDefault();
    const productItem = toggleBtn.closest('.ProductItem');
    
    // Find the appropriate product-card-actions based on screen size
    // For desktop (lg:block), it's inside ProductItem__image-holder
    // For mobile (lg:hidden), it's at the bottom of ProductItem
    let productCardActions;
    
    if (window.innerWidth >= 1024) { // lg breakpoint is typically 1024px
      productCardActions = productItem.querySelector('.ProductItem__image-holder product-card-actions');
    } else {
      productCardActions = productItem.querySelector('.lg\\:hidden product-card-actions');
    }
    
    // If we couldn't find the product-card-actions in the expected container, try to find it anywhere in the product item
    if (!productCardActions) {
      productCardActions = productItem.querySelector('product-card-actions');
    }
    
    // Close any other open bottom sheets first (for mobile only)
    if (window.innerWidth < 1024) {
      const allActiveBottomSheets = document.querySelectorAll('product-card-actions.active');
      const allActiveQuickAddButtons = document.querySelectorAll('.quickAdd_bag.active');
      
      allActiveBottomSheets.forEach(sheet => {
        if (sheet !== productCardActions) {
          sheet.classList.remove('active');
          const cardForm = sheet.querySelector('.card-form-js');
          const variantOptions = sheet.querySelector('.variant-options-js');
          const addToCartButton = sheet.querySelector('.add-to-cart-button-js');
          
          if (cardForm) cardForm.classList.add('hidden');
          if (addToCartButton) addToCartButton.classList.add('hidden');
          if (variantOptions) variantOptions.classList.add('hidden');
        }
      });
      
      allActiveQuickAddButtons.forEach(btn => {
        if (btn !== toggleBtn) {
          btn.classList.remove('active');
        }
      });
    }
    
    if (productCardActions) {
      // Find required elements within the product-card-actions
      const cardForm = productCardActions.querySelector('.card-form-js');
      const variantOptions = productCardActions.querySelector('.variant-options-js');
      const addToCartButton = productCardActions.querySelector('.add-to-cart-button-js');
      
      const bagIcon = toggleBtn.querySelector('.bag-icon');

      // Check if this is an out of stock product
      const isOutOfStock = productCardActions.classList.contains('not-fixed');

      if (toggleBtn.classList.contains('active')) {
        // If the button is active, it means the close icon is showing
        // Add hidden class when the close icon is clicked
        if (cardForm) cardForm.classList.add('hidden');
        if (addToCartButton) addToCartButton.classList.add('hidden');
        if (variantOptions) variantOptions.classList.add('hidden');

        toggleBtn.classList.remove('active');
        
        // For mobile bottom sheet, also remove active class from product-card-actions
        if (!isOutOfStock && window.innerWidth < 1024) {
          productCardActions.classList.remove('active');
        }
      } else {
        // If the button is not active, it means the bag icon is showing
        // Remove hidden class when the main bag icon is clicked
        if (cardForm) cardForm.classList.remove('hidden');
        if (addToCartButton) addToCartButton.classList.remove('hidden');
        if (variantOptions) variantOptions.classList.remove('hidden');

        toggleBtn.classList.add('active');
        
        // For mobile bottom sheet, also add active class to product-card-actions
        if (!isOutOfStock && window.innerWidth < 1024) {
          productCardActions.classList.add('active');
        }
        
        // Auto-select the first available variant when opening the options
        // This works for both mobile and desktop
        selectFirstAvailableVariant(productCardActions);
      }
      
      // If this is the quickAdd_bag button, also trigger a click on the show-options-js button inside product-card-actions
      if (toggleBtn.classList.contains('quickAdd_bag') && !toggleBtn.classList.contains('show-options-js-triggered')) {
        const showOptionsBtn = productCardActions.querySelector('.show-options-js');
        if (showOptionsBtn && !toggleBtn.classList.contains('active')) {
          toggleBtn.classList.add('show-options-js-triggered');
          setTimeout(() => {
            toggleBtn.classList.remove('show-options-js-triggered');
          }, 100);
        }
      }
    }
  }
});

// Handle hover events for product videos
document.addEventListener('DOMContentLoaded', function() {
  // Function to handle hover video playback
  function setupHoverVideoPlayback() {
    document.querySelectorAll('.ProductItem__ImageWrapper').forEach(wrapper => {
      const hoverVideo = wrapper.querySelector('.ProductItem__Image--alternate.ProductItem__Video');
      
      if (hoverVideo) {
        // Play video on hover
        wrapper.addEventListener('mouseenter', function() {
          if (hoverVideo.paused) {
            hoverVideo.play().catch(e => console.error('Error playing hover video:', e));
          }
        });
        
        // Pause video when hover ends
        wrapper.addEventListener('mouseleave', function() {
          if (!hoverVideo.paused) {
            hoverVideo.pause();
            // Reset to beginning for next hover
            hoverVideo.currentTime = 0;
          }
        });
      }
    });
  }
  
  // Initial setup
  setupHoverVideoPlayback();
  
  // Re-run setup when the page content might have changed (e.g., after AJAX loads)
  document.addEventListener('shopify:section:load', setupHoverVideoPlayback);
  document.addEventListener('product:added', setupHoverVideoPlayback);
});

// Handle mouse leave on product media holder - closes the quick add
document.querySelectorAll('.ProductItem__image-holder').forEach(holder => {
  holder.addEventListener('mouseleave', function() {
    const productItem = this.closest('.ProductItem');
    const quickAddBag = productItem.querySelector('.quickAdd_bag');
    const productCardActions = productItem.querySelector('product-card-actions');

    if (quickAddBag && quickAddBag.classList.contains('active')) {
      quickAddBag.classList.remove('active');
      
      if (productCardActions) {
        const cardForm = productCardActions.querySelector('.card-form-js');
        const variantOptions = productCardActions.querySelector('.variant-options-js');
        const addToCartButton = productCardActions.querySelector('.add-to-cart-button-js');

        // Hide elements
        if (cardForm) cardForm.classList.add('hidden');
        if (addToCartButton) addToCartButton.classList.add('hidden');
        if (variantOptions) variantOptions.classList.add('hidden');
      }
    }
  });
});

// Remove transform on grid items
document.addEventListener('DOMContentLoaded', function() {
  function removeGridTransform() {
    document.querySelectorAll('.ProductList--grid.Grid').forEach(grid => {
      grid.style.transform = 'none'; // Remove transform
    });
  }

  // Run initially
  removeGridTransform();

  // Re-run when sections reload (e.g. after filter changes)
  document.addEventListener('shopify:section:load', removeGridTransform);
  
  // Also run when bottom sheet is opened or closed
  document.addEventListener('click', function(event) {
    if (event.target.closest('.quickAdd_bag') || event.target.closest('.close-bottom-sheet')) {
      setTimeout(removeGridTransform, 100); // Small delay to ensure it runs after the bottom sheet animation
    }
  });
});